import ButtonGorup from '../../libs/ui/buttons/ButtonGroup'
import RadioButton from '../../libs/ui/buttons/RadioButton'
import { BaseComponent, BaseProps } from '../../libs/ui/BaseComponent'


export type SiNoType  = 'si' | 'no' | undefined

export function getSiNoValue (bol: boolean | undefined) : SiNoType  {
    return (bol === undefined)
            ? undefined
            : ((bol) ? 'si' : 'no')
}

export function getBoolean (siNo: SiNoType) {
    return (siNo === undefined)
        ? undefined
        : (siNo === 'si')
}

interface SiNoState {}

interface SiNoProps extends BaseProps {
    value: SiNoType,
    label: string
    callback?: Function
}

class SiNo extends BaseComponent<SiNoProps, SiNoState> {

    render () {
        const activeId = (this.props.value !== undefined) 
            ? this.props.id + '_' + this.props.value 
            : undefined

        return (
            <ButtonGorup 
                id={this.props.id}
                label={this.props.label}
                value={this.props.value}
                callback={this.props.callback}
                error={this.props.error}
            >
                <RadioButton 
                    key={'si'}
                    id={this.props.id + '_si'} name={this.props.name} 
                    label="Si" 
                    value="si" 
                    activeId={ activeId }
                />
                <RadioButton 
                    key={'no'}
                    id={this.props.id + '_no'} name={this.props.name} 
                    label="No" 
                    value="no" 
                    activeId={ activeId }
                />
            </ButtonGorup>   
        )
    }
}

export default SiNo